import React from 'react'
import store from '../../store/Store'

import PageSelection from '../pageSelection/PageSelection'
import PageContent from '../pageContent/PageContent'

import './template.scss'

type templateState = {
	article: any;
	navigation: any;
}

type templateProps = {
	article: any;
	navigation: any;
}

class Template extends React.Component<templateState, templateProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
  		navigation: props.navitaion
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article,
			navigation: store.getState().navigation
		})
	})
  }

  render() {
  	  const {
  	  	article,
  	  	navigation
  	  } = this.state

	  return (
	  	<div
	  		className="Template"
	  	>
	  		<div
	  			className="TemplateContent"
	  		>
	  			<PageContent 
	  				article={ article } 
	  				navigation={ navigation } 
	  			/>
	  		</div>

		</div>
	  );
	}
}

export default Template;